import {ButtonHTMLAttributes, forwardRef, ReactElement} from "react";
import React from "react";
import styled from "styled-components";

import {breakpoints, quicksandSemiBold, shadowButton} from "@/GlobalStyle";

const ButtonStyled = styled.button<{$variant: string; $isCircle: boolean}>`
  border-radius: ${({$isCircle}) => ($isCircle ? "50px" : "0px")};
  aspect-ratio: ${({$isCircle}) => ($isCircle ? "1" : "auto")};

  background-color: ${({$variant, theme}) => {
    switch ($variant) {
      case "primary":
        return theme.colors.darkPrimary;
      case "secondary":
        return theme.colors.mediumSecondary;
      case "light_primary":
        return theme.colors.lightPrimary;
      case "negate":
        return theme.colors.alert;
      case "negatif_primary":
      case "negatif_secondary":
      case "negatif_light_primary":
        return "white";
      case "validate":
        return theme.colors.validate;

      default:
        return "transparent"; // ou une couleur par défaut
    }
  }};
  border: 0px;
  color: ${({$variant, theme}) => {
    switch ($variant) {
      case "negatif_primary":
        return theme.colors.darkPrimary;
      case "negatif_secondary":
        return theme.colors.mediumSecondary;
      case "negatif_light_primary":
        return theme.colors.lightPrimary;
      default:
        return "white"; // ou une couleur par défaut
    }
  }};
  border: ${({$variant, theme}) => {
    switch ($variant) {
      case "negatif_primary":
        return `2px solid ${theme.colors.darkPrimary}`;
      case "negatif_light_primary":
        return `2px solid ${theme.colors.lightPrimary}`;
      case "negatif_secondary":
        return `2px solid ${theme.colors.mediumSecondary}`;
      default:
        return "none"; // ou une couleur par défaut
    }
  }};
  padding: ${({$isCircle}) => ($isCircle ? "5px 10px" : "10px 15px")};
  ${shadowButton}
  ${quicksandSemiBold}
  letter-spacing: 1PX;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:not(:disabled) {
    &:hover {
      transform: scale(1.02);
      transition: transform 0.2s ease-in-out;
    }

    &:active {
      transform: scale(1) !important;
      transition: transform 0.1s ease-in-out !important;

      box-shadow: inset 0px 0px 10px rgb(00, 00, 00, 0.3);
    }
  }

  & div img,
  & div svg {
    max-width: 20px;
    max-height: 16px;

    fill: ${({$variant, theme}) => {
      switch ($variant) {
        case "negatif_primary":
          return theme.colors.darkPrimary;
        case "negatif_light_primary":
          return theme.colors.lightPrimary;
        case "negatif_secondary":
          return theme.colors.mediumSecondary;
        default:
          return "white"; // ou une couleur par défaut
      }
    }};
    @media (max-widh: ${breakpoints.md}) {
      width: 0.875rem;
    }
  }
`;
const IconContent = styled.div<{$isCircle: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 16px;
  margin: ${({$isCircle}) => ($isCircle ? "auto" : "0px")};
`;

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: string;
  label?: string;
  isCircle?: boolean;
  icon?:
    | string
    | React.FunctionComponent<React.SVGProps<SVGSVGElement>>
    | ReactElement;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {variant = "secondary", isCircle = false, label, icon, ...rest},
    ref
  ): ReactElement => {
    return (
      <ButtonStyled ref={ref} $variant={variant} $isCircle={isCircle} {...rest}>
        {icon ? (
          typeof icon === "string" ? (
            <IconContent $isCircle={isCircle}>
              <img src={icon} alt={`icon button ${label}`} />
            </IconContent>
          ) : typeof icon === "function" ? (
            <IconContent $isCircle={isCircle}>
              {React.createElement(icon)}
            </IconContent>
          ) : (
            <IconContent $isCircle={isCircle}>{icon}</IconContent>
          )
        ) : null}

        {label ? <span>{label?.toUpperCase()}</span> : null}
      </ButtonStyled>
    );
  }
);

Button.displayName = "Button";
